import { FormControl, IconButton } from '@material-ui/core';
import * as lib from '~/dependencies';
import { measures, colors, borders, paddings, fonts, margins } from '~/layout';

const subtractBorder = value => borders.height * value;

export const Container = lib.styled.div`
  margin-bottom: ${props =>
    props.validator
      ? margins.inputBottom * 2.5 - 14
      : margins.inputBottom * 1.5}px;

  .controlForm {
    display: flex;
    max-width: ${measures.authScreen.inputLogin.width}px;

    .fix-adornment {
      margin-right: 0px!important;
    }
    .label {
      font-size: ${fonts.label}px;
      color: ${colors.black};
      margin-bottom: ${margins.labelBottom}px;
    }
    .auth-input {
      width: ${measures.authScreen.inputLogin.width}px;
      height: ${measures.authScreen.inputLogin.height}px;
      border: ${borders.height}px solid;
      border-radius: ${borders.radius}px;
      padding: ${measures.reset}px;
      border-color: ${props =>
        props.validator ? colors.red : colors.lightGray06};

      div::after {
        border: ${props => (props.validator ? 0 : 2)}px solid;
        border-color: ${colors.lightBlue}!important;
        height: ${measures.authScreen.inputLogin.height - subtractBorder(4)}px;
        border-radius: ${borders.radius}px;
      }
      div::before { border-bottom: ${measures.reset}!important; }
      input {
        padding: ${measures.reset}px;
        padding-left: ${paddings.input}px;
        padding-right: ${paddings.input}px;
        height: ${measures.authScreen.inputLogin.height}px;
      }
    }
  }
`;

export const FormControlStyled = lib.styled(FormControl)`

`;

export const IconButtonStyled = lib.styled(IconButton)`
  .icon {
    font-size: 18px;
    opacity: 0.5;
  }
`;

export const BoxErrors = lib.styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  span {
    font-size: 10px;
    color: ${colors.red};
    text-align: left;
  }
`;
